import { ref } from 'vue';

import useAxios from '@/util/axios';

const persisting = ref(false);

export default function useApi() {
	const axios = useAxios();
	const { api } = axios;

	const endpoint = 'https://raq7php7f7.execute-api.me-south-1.amazonaws.com/prod/contact';

	const persistForm = async (payload: Object) => {
		persisting.value = true;

		await api
			.post(endpoint, JSON.stringify(payload), {
				headers: {
					'Content-Type': 'text/plain'
				}
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				persisting.value = false;
			});
	};

	return {
		persisting,
		persistForm
	};
}
